import React, { createContext, useContext } from "react";

const ProductSurfaceContext = createContext(null);

export function ProductSurfaceProvider({ value, children }) {
  return (
    <ProductSurfaceContext.Provider value={value || null}>
      {children}
    </ProductSurfaceContext.Provider>
  );
}

export function useProductSurface() {
  return useContext(ProductSurfaceContext);
}

export default ProductSurfaceContext;
